export const DEFAULT_PROCESS_VERSION = 0;
export const INPUT_TAB_KEY = "input-tab-key";
export const OUTPUT_TAB_KEY = "output-tab-key";
export const UNIT_RECORD_TAB_KEY = "unit-record-tab-key";
